export default {
  email: 'Invalid email address',
  noChangesDetected: 'No changes detected',
}
